import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "header d-flex align-items-center fixed-top"
}
const _hoisted_2 = { class: "container-fluid container-xl position-relative d-flex align-items-center justify-content-between" }
const _hoisted_3 = {
  id: "navmenu",
  class: "navmenu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/e-paiement",
        class: "logo d-flex align-items-center"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("h1", { class: "sitename" }, "SOGEMA EN LIQUIDATION", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", null, [
          _cache[3] || (_cache[3] = _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "#",
              class: "active"
            }, "SOGEMA")
          ], -1)),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/login" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Se connecter", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("i", {
          class: "mobile-nav-toggle d-xl-none bi bi-list",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args)))
        })
      ])
    ])
  ]))
}